import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  InputGroup,
  InputRightAddon,
  Radio,
  RadioGroup,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Toast from "../Components/Toast";
import { TsdsInput } from "../Components/TsdsInput";
import { DOMAIN_AVAILABLE } from "../Constants/urls";
import { useAppDispatch } from "../Hooks/useAppDispatch";
import { useAppSelector } from "../Hooks/useAppSelector";
import { useDebounce } from "../Hooks/useDebounce";
import {
  getRole,
  getToken,
  selectAdminFetching,
  store_onboard,
} from "../Redux/AdminSlice";
import { displayToast } from "../Redux/ToastSlice";

const OnboardingScreen = () => {
  const token = useAppSelector<string>(getToken);
  const fetching = useAppSelector<boolean>(selectAdminFetching);
  const role = useAppSelector<string>(getRole);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [domain, setDomain] = useState("");
  const debouncedDomain = useDebounce(domain);
  const [isDomainAvail, setIsDomianAvail] = useState(true);

  useEffect(() => {
    if (!token) {
      navigate("/home");
    }
    if (!!role && role !== "admin" && role !== "fots" && role !== "sales") {
      navigate("/home");
    }
  }, [token, role]);

  useEffect(() => {
    (async () => {
      if (domain.length <= 0) {
        setIsDomianAvail(true)
        return;
      }
      try {
        const res = await fetch(DOMAIN_AVAILABLE + '/' + domain)
        if (res.ok) {
          setIsDomianAvail(true)
        } else {
          setIsDomianAvail(false)
        }
      } catch (error) {
        setIsDomianAvail(false)
      }
    })()
  }, [debouncedDomain])

  async function handleDomain(e: ChangeEvent<HTMLInputElement>) {
    const inputValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    formik.setFieldValue('store_info.domain', inputValue);
    setDomain(inputValue)
  }
  const formik = useFormik({
    initialValues: {
      user_info: {
        email: "",
        password: "",
      },
      store_info: {
        name: "",
        domain: "",
        mobile_num: "",
        store_email: "",
        address: "",
        street: "",
        area: "",
        city: "",
        district: "",
        state: "",
        pin_code: "",
        landmark: "",
        location_gps: "",
        established_year: "",
        employees_count: 0,
        avg_ann_rev: 0,
        location_desc_1: "",
        location_desc_2: "",
        location_desc_3: "",
        khata_trigger_amount: 0,
        trade_license: "",
        trade_GSTIN: "",
        trade_PAN: "",
        trade_TAN: "",
      },
      proprietor: {
        first_name: "",
        last_name: "",
        mobile_num: "",
        email: "",
        address: "",
        street: "",
        city: "",
        district: "",
        state: "",
        pin_code: "",
        landmark: "",
        gender: "",
      },
    },
    onSubmit: (values) => {
      const email = values.user_info.email + '@' + values.store_info.domain
      const updatedValues = {
        ...values,
        user_info: {
          ...values.user_info,
          email: email,
        },
      };
      if (!isDomainAvail) {
        dispatch(displayToast("Domain not Available"))
      };
      dispatch(store_onboard(updatedValues, () => navigate("/home")));
    },
  });

  return (
    <Box px={5}>
      <form className="accordion" onSubmit={formik.handleSubmit}>
        <Toast />
        <Accordion defaultIndex={[0]} allowMultiple>
          <AccordionItem>
            <h2>
              <AccordionButton bg="#B2101D">
                <Box color="white" flex="1" textAlign="left">
                  User Information
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <TsdsInput
                label="Store Domain"
                type="text"
                name="store_info.domain"
                value={domain}
                onChange={handleDomain}
                onBlur={formik.handleBlur}
                isRequired
              />
              {!isDomainAvail && <Text fontSize={'xs'} color='red'>Domain is not Available</Text>}
              <InputGroup>
                <TsdsInput
                  label="Username"
                  type="text"
                  name="user_info.email"
                  value={formik.values.user_info.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isRequired
                />
                <InputRightAddon marginTop={'6'} children={'@' + formik.values.store_info.domain} />
              </InputGroup>
              <TsdsInput
                label="Password"
                type="password"
                name="user_info.password"
                value={formik.values.user_info.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <h2>
              <AccordionButton bg="#FCDD0D">
                <Box flex="1" textAlign="left">
                  Store Information
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <TsdsInput
                label="Store Name"
                type="text"
                name="store_info.name"
                value={formik.values.store_info.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
              <TsdsInput
                label="Mobile Number"
                type="text"
                name="store_info.mobile_num"
                value={formik.values.store_info.mobile_num}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
              <TsdsInput
                label="Email Address"
                type="email"
                name="store_info.store_email"
                value={formik.values.store_info.store_email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Address"
                type="text"
                name="store_info.address"
                value={formik.values.store_info.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
              <TsdsInput
                label="Street"
                type="text"
                name="store_info.street"
                value={formik.values.store_info.street}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Area"
                type="text"
                name="store_info.area"
                value={formik.values.store_info.area}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="City"
                type="text"
                name="store_info.city"
                value={formik.values.store_info.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="District"
                type="text"
                name="store_info.district"
                value={formik.values.store_info.district}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="State"
                type="text"
                name="store_info.state"
                value={formik.values.store_info.state}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Pin Code"
                type="text"
                name="store_info.pin_code"
                value={formik.values.store_info.pin_code}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Landmark"
                type="text"
                name="store_info.landmark"
                value={formik.values.store_info.landmark}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Location GPS"
                type="text"
                name="store_info.location_gps"
                value={formik.values.store_info.location_gps}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <h2>
              <AccordionButton bg="#9EB0AA">
                <Box flex="1" textAlign="left">
                  Proprietor Details
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <TsdsInput
                label="First Name"
                type="text"
                name="proprietor.first_name"
                value={formik.values.proprietor.first_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
              <TsdsInput
                label="Last Name"
                type="text"
                name="proprietor.last_name"
                value={formik.values.proprietor.last_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Mobile Number"
                type="text"
                name="proprietor.mobile_num"
                value={formik.values.proprietor.mobile_num}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
              <TsdsInput
                label="Email Address"
                type="email"
                name="proprietor.email"
                value={formik.values.proprietor.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Address"
                type="text"
                name="proprietor.address"
                value={formik.values.proprietor.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRequired
              />
              <TsdsInput
                label="Street"
                type="text"
                name="proprietor.street"
                value={formik.values.proprietor.street}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="City"
                type="text"
                name="proprietor.city"
                value={formik.values.proprietor.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="District"
                type="text"
                name="proprietor.district"
                value={formik.values.proprietor.district}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="State"
                type="text"
                name="proprietor.state"
                value={formik.values.proprietor.state}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Pin Code"
                type="text"
                name="proprietor.pin_code"
                value={formik.values.proprietor.pin_code}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Landmark"
                type="text"
                name="proprietor.landmark"
                value={formik.values.proprietor.landmark}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <FormControl>
                <FormLabel>Gender</FormLabel>
                <RadioGroup
                  name="proprietor.gender"
                  value={formik.values.proprietor.gender}
                  onChange={(value) =>
                    formik.setFieldValue("proprietor.gender", value)
                  }
                  onBlur={formik.handleBlur}
                >
                  <HStack direction="row">
                    <Radio value="Male">Male</Radio>
                    <Radio value="Female">Female</Radio>
                    <Radio value="Other">Other</Radio>
                  </HStack>
                </RadioGroup>
              </FormControl>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <h2>
              <AccordionButton bg="#FD6D50">
                <Box flex="1" textAlign="left">
                  Additional Store Information
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <TsdsInput
                label="Established Year"
                type="text"
                name="store_info.established_year"
                value={formik.values.store_info.established_year}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Employees Count"
                type="number"
                name="store_info.employees_count"
                value={formik.values.store_info.employees_count}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Average Annual Revenue"
                type="number"
                name="store_info.avg_ann_rev"
                value={formik.values.store_info.avg_ann_rev}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Location Description 1"
                type="text"
                name="store_info.location_desc_1"
                value={formik.values.store_info.location_desc_1}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Location Description 2"
                type="text"
                name="store_info.location_desc_2"
                value={formik.values.store_info.location_desc_2}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Location Description 3"
                type="text"
                name="location_desc_3"
                value={formik.values.store_info.location_desc_3}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Khata Trigger Amount (Max amount of Khata that the shop gives)"
                type="number"
                name="store_info.khata_trigger_amount"
                value={formik.values.store_info.khata_trigger_amount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Trade License"
                type="text"
                name="store_info.trade_license"
                value={formik.values.store_info.trade_license}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Trade GSTIN"
                type="text"
                name="store_info.trade_GSTIN"
                value={formik.values.store_info.trade_GSTIN}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Trade PAN"
                type="text"
                name="store_info.trade_PAN"
                value={formik.values.store_info.trade_PAN}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TsdsInput
                label="Trade TAN"
                type="text"
                name="store_info.trade_TAN"
                value={formik.values.store_info.trade_TAN}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
        <div style={{ textAlign: "center", margin: "10px" }}>
          <Button type="submit">
            Submit {fetching ? <Spinner size="sm" ml={2} /> : <></>}
          </Button>
        </div>
      </form>
    </Box>
  );
};

export default OnboardingScreen;
